import React, {useState, useRef , useEffect} from 'react';
import {Box, Button, Drawer, IconButton, TextField, Typography} from "@mui/material";
import CustomButtoncolor from "../custom-button/customColorButton";
import {useDispatch} from "react-redux";
import {PlayArrow} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {FormLinkData, getAllSubmittedTreatmentForms, getAllTreatmentForms} from "../../store/user/chart-form";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { MySwal } from '../../services/utills';
import Waveloading from '../../pages/loading/Waveloading';
import LinkModal from './LinkModal';
import ArticleIcon from '@mui/icons-material/Article';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BarChartIcon from '@mui/icons-material/BarChart';
import SendIcon from '@mui/icons-material/Send';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import moment from 'moment';
import toast from 'react-hot-toast';
import { getSentForms, recordSentForm, resolveFormMeta } from '../../utils/sentFormsLog';

const TreatmentFormButton = ({data, crmStyle, completed, fwidth, fsize, isbtn }) => {
    const [loading, setLoading] = useState(false);
    const [treatmentForm, setTreatmentForm] = useState(null);
    const [allTreatmentForms, setAllTreatmentForms] = useState([]);
    const [allSubmittedForm, setAllSubmittedForm] = useState([]);
    const [search, setSearch] = useState('');
    const [active, setActive] = useState(0);
    // Which half of the Submitted tab is showing: what we emailed out, or what came back.
    const [submittedView, setSubmittedView] = useState('sent');
    const [sentForms, setSentForms] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLinkUrl, setSelectedLinkUrl] = useState(null);
    const scrollableRef = useRef(null);

    const handleKeyDown = (event) => {
        if (event.key === 'ArrowDown' && scrollableRef.current) {
            scrollableRef.current.scrollBy(0, 10);
        }
    };

    useEffect(() => {
        const el = scrollableRef.current;
        if (el) {
            el.addEventListener('keydown', handleKeyDown);
            el.tabIndex = "0";
            el.style.outline = "none";
        }
        return () => {
            if (el) el.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const openModal = (linkUrl) => {
        setSelectedLinkUrl(linkUrl);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setSelectedLinkUrl(null);
        setIsModalOpen(false);
    };

    const handleChanges = (event) => setSearch(event.target.value);

    const filterForms = (forms, q) =>
        forms?.filter(form => form.name.toLowerCase().includes(q.toLowerCase())) || [];

    const filteredForms = filterForms(allTreatmentForms?.consent, search);
    const filteredCustomerForm = filterForms(allTreatmentForms?.customer_service_form, search);
    const filteredChartForm = filterForms(allTreatmentForms?.chart_form, search);
    const filteredSubmitForm = allSubmittedForm?.consent?.filter(form =>
        form.name.toLowerCase().includes(search.toLowerCase())
    );
    // Submitted tab search must filter every section, not just Consent.
    const filteredSubmitCustomerForm = allSubmittedForm?.customer_service_form?.filter(form =>
        (form?.name || "").toLowerCase().includes(search.toLowerCase())
    );
    const filteredSubmitChartForm = allSubmittedForm?.chart_form?.filter(form =>
        (form?.name || "").toLowerCase().includes(search.toLowerCase())
    );

    const defaultId = data?.customer_id || data?.id;
    const customerId = data?.customer_id || data?.customer?.id;
    const requestType = data?.customer_id ? "CRM" : "Appointment";
    // Who the emailed link goes to — shown against each row in the Sent section.
    const customerName = data?.customer_name || data?.name || data?.customer?.name || '';
    const customerEmail = data?.email || data?.customer?.email || '';

    const filteredSentForms = sentForms?.filter(form =>
        (form?.name || "").toLowerCase().includes(search.toLowerCase())
    ) || [];

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleFetchForm = async () => {
        setLoading(true);
        const finalData = {id: defaultId, provider_id: data?.provider?.id, type: requestType};
        setTreatmentForm(finalData);
        const {payload} = await dispatch(getAllTreatmentForms(finalData));
        setLoading(false);
        setAllTreatmentForms(payload);
        setSentForms(getSentForms(customerId));
    };

    const handleFormClick = (url) => openModal(url);

    const handleRowClick = async (userid, formid) => {
        const confirm = await MySwal.fire({
            title: " Email Send ?",
            showConfirmButton: false,
            customClass: {icon: 'custom-icon-size', popup: 'custom-popup-shadow', closeButton: 'custom-close-button'},
            showCloseButton: true,
            html: (
                <Box>
                    <Box sx={{mt: 3, display: "flex", flexDirection: {lg: "row", md: "row", sm: "row", xs: "column"}, gap: "12px", justifyContent: "center"}}>
                        <Button sx={{background: "#27AE60", color: "#fff", minWidth: "150px", border: "1px solid #27AE60", borderRadius: '10px', fontSize: '16px', px: '20px', mx: '10px', boxShadow: "none", "&:hover": {background: "#219653", color: "#fff", border: "1px solid #27AE60", boxShadow: "none"}}} onClick={() => MySwal.clickConfirm()}>YES</Button>
                        <Button sx={{backgroundColor: "#EB5757", color: "#fff", minWidth: "150px", border: "1px solid #EB5757", borderRadius: '10px', fontSize: '16px', px: '20px', mx: '10px', boxShadow: "none", "&:hover": {backgroundColor: "#fff", color: "#EB5757", border: "1px solid #EB5757", boxShadow: "none"}}} onClick={() => MySwal.close()}>NO</Button>
                    </Box>
                </Box>
            ),
        });
        if (!!confirm?.isConfirmed) {
            setLoading(true);
            const {payload} = await dispatch(FormLinkData({user_id: userid, form_id: formid}));
            setLoading(false);

            // Treated as sent unless the API says otherwise: the thunk returns the
            // raw response body on success and `undefined`/an error body when the
            // request itself failed.
            const sendFailed = !payload
                || payload?.success === false || payload?.success === 'false'
                || !!payload?.errors;

            if (!sendFailed) {
                // Log the send so it shows under Submitted > Sent. The form's name
                // and type are looked up here so every mail button keeps its
                // existing (userid, formid) signature.
                const meta = resolveFormMeta(allTreatmentForms, formid) || resolveFormMeta(allSubmittedForm, formid);
                recordSentForm({
                    customer_id: customerId || userid,
                    link_customer_id: userid || customerId,
                    treatment_form_id: formid,
                    name: meta?.name || 'Client form',
                    url: meta?.url,
                    tag: meta?.tag,
                    customer_name: customerName,
                    customer_email: customerEmail,
                });
                setSentForms(getSentForms(customerId, allSubmittedForm?.sent));
                toast.success(payload?.message || 'Form link sent successfully.');
            } else {
                toast.error(payload?.message || 'Could not send the form link.');
            }
        }
    };

    const fetchSubmittedForms = async () => {
        const {payload} = await dispatch(getAllSubmittedTreatmentForms({id: customerId, provider_id: data?.provider?.id}));
        setAllSubmittedForm(payload);
        setSentForms(getSentForms(customerId, payload?.sent));
        return payload;
    };

    const handleSubmitted = async () => {
        setLoading(true);
        setActive(3);
        await fetchSubmittedForms();
        setLoading(false);
    };

    const tagMeta = {
        Consent: { color: '#27AE60', icon: <CheckCircleIcon sx={{fontSize:12, color:'#27AE60'}} /> },
        Service: { color: '#2F80ED', icon: <CalendarMonthIcon sx={{fontSize:12, color:'#2F80ED'}} /> },
        Chart:   { color: '#F2994A', icon: <BarChartIcon sx={{fontSize:12, color:'#F2994A'}} /> },
    };
    const tabs = [
        { id: 0, label: 'All Forms', icon: <ArticleIcon sx={{fontSize:14}} /> },
        { id: 4, label: 'Consent',   icon: <CheckCircleIcon sx={{fontSize:14, color: active===4 ? '#fff' : '#27AE60'}} /> },
        { id: 1, label: 'Service',   icon: <CalendarMonthIcon sx={{fontSize:14, color: active===1 ? '#fff' : '#2F80ED'}} /> },
        { id: 2, label: 'Chart',     icon: <BarChartIcon sx={{fontSize:14, color: active===2 ? '#fff' : '#F2994A'}} /> },
        { id: 3, label: 'Submitted', icon: <SendIcon sx={{fontSize:14, color: active===3 ? '#fff' : '#2F80ED'}} /> },
    ];

    const formRow = (form, tag, onRowClick, rightExtra, subLine) => (
        <Box
            key={`${tag}-${form?.id || form?.treatment_form_id || form?.submitted_id}-${form?.name}`}
            onClick={onRowClick}
            sx={{
                display: 'flex', alignItems: 'center', gap: 1,
                background: '#FAFAFC', border: '1px solid #F0F1F4',
                borderRadius: '12px', p: '10px 12px', mb: '8px', cursor: 'pointer',
                transition: 'background 0.15s, border-color 0.15s',
                '&:hover': { background: '#FAEFF5', borderColor: '#F0CDDB' },
            }}
        >
            <ChevronRightIcon sx={{color: '#A72C68', fontSize: 18, flexShrink: 0}} />
            <Box sx={{width: 32, height: 32, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                <ArticleIcon sx={{color: '#A72C68', fontSize: 17}} />
            </Box>
            <Box sx={{flex: 1, minWidth: 0}}>
                <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#1a1a2e', lineHeight: 1.25, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                    {form?.name}
                </Typography>
                {tag && (
                    <Box sx={{display: 'inline-flex', alignItems: 'center', gap: 0.4, mt: '2px'}}>
                        {tagMeta[tag]?.icon}
                        <Typography sx={{fontSize: '11px', fontWeight: 600, color: tagMeta[tag]?.color}}>{tag}</Typography>
                    </Box>
                )}
                {subLine && (
                    <Typography sx={{fontSize: '11px', color: '#8a8d97', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        {subLine}
                    </Typography>
                )}
            </Box>
            {rightExtra}
        </Box>
    );

    const mailBtn = (form) => (
        <IconButton
            size="small"
            onClick={(e) => { e.stopPropagation(); handleRowClick(form?.customer_id, form?.treatment_form_id); }}
            sx={{color: '#A72C68', background: '#F3EEFF', borderRadius: '8px', '&:hover': {background: '#F0CDDB'}}}
        >
            <AttachEmailIcon sx={{fontSize: 16}} />
        </IconButton>
    );

    const emptyMsg = (msg) => <Typography sx={{textAlign: 'center', mt: '24px', color: '#9ca3af', fontSize: '13px'}}>{msg}</Typography>;

    const onFormOpen = (form) => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`);
    const onSubmittedOpen = (form) => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`);
    const onSentOpen = (entry) => (entry?.url
        ? handleFormClick(`${window?.location?.origin}/crm/${entry?.link_customer_id || entry?.customer_id}/${entry?.url}`)
        : undefined);

    // A sent form counts as returned once the same form shows up in the submitted
    // payload. Ids are matched first, with the name as a fallback because the two
    // endpoints don't always key their rows the same way.
    const submittedKeys = new Set();
    [
        ...(allSubmittedForm?.consent || []),
        ...(allSubmittedForm?.customer_service_form || []),
        ...(allSubmittedForm?.chart_form || []),
    ].forEach(form => {
        if (form?.treatment_form_id != null) submittedKeys.add(`id:${form.treatment_form_id}`);
        if (form?.name) submittedKeys.add(`name:${form.name.toLowerCase()}`);
    });
    const isSentBack = (entry) => submittedKeys.has(`id:${entry?.treatment_form_id}`)
        || (!!entry?.name && submittedKeys.has(`name:${entry.name.toLowerCase()}`));

    const statusChip = (returned) => (
        <Box sx={{
            display: 'inline-flex', alignItems: 'center', gap: 0.4, px: '8px', py: '3px', borderRadius: '7px',
            background: returned ? '#E9F8EF' : '#FFF4E6',
            border: `1px solid ${returned ? '#C9EDD8' : '#FBE0BE'}`,
        }}>
            {returned
                ? <AssignmentTurnedInIcon sx={{fontSize: 12, color: '#27AE60'}} />
                : <ScheduleSendIcon sx={{fontSize: 12, color: '#F2994A'}} />}
            <Typography sx={{fontSize: '10px', fontWeight: 700, color: returned ? '#27AE60' : '#F2994A', whiteSpace: 'nowrap'}}>
                {returned ? 'Submitted' : 'Awaiting'}
            </Typography>
        </Box>
    );

    const sentRow = (entry) => {
        const returned = isSentBack(entry);
        const sentAt = entry?.sent_at ? moment(entry.sent_at) : null;
        return formRow(
            entry,
            entry?.tag,
            () => onSentOpen(entry),
            <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0}}>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '3px'}}>
                    {statusChip(returned)}
                    {sentAt?.isValid() && (
                        <Typography sx={{fontSize: '10px', fontWeight: 600, color: '#8a8d97', whiteSpace: 'nowrap'}}>
                            {sentAt.format('MMM D, YYYY HH:mm')}
                        </Typography>
                    )}
                </Box>
                {/* Resend to the same client without leaving the tab */}
                <IconButton
                    size="small"
                    title="Resend email"
                    onClick={(e) => { e.stopPropagation(); handleRowClick(entry?.link_customer_id || entry?.customer_id, entry?.treatment_form_id); }}
                    sx={{color: '#A72C68', background: '#F3EEFF', borderRadius: '8px', '&:hover': {background: '#F0CDDB'}}}
                >
                    <AttachEmailIcon sx={{fontSize: 16}} />
                </IconButton>
            </Box>,
            entry?.customer_email
                ? `Emailed to ${entry?.customer_name ? `${entry.customer_name} · ` : ''}${entry.customer_email}`
                : (entry?.customer_name ? `Emailed to ${entry.customer_name}` : 'Email sent'),
        );
    };

    const submittedCount = (filteredSubmitForm?.length || 0)
        + (filteredSubmitCustomerForm?.length || 0)
        + (filteredSubmitChartForm?.length || 0);

    // Each view keeps a colour of its own — blue for what went out, green for what
    // came back — so both read as "live" and the selected one is unmistakable:
    // solid fill when active, the same hue softened when not.
    const subTabMeta = {
        sent: {
            label: 'Sent', Icon: MarkEmailReadIcon,
            color: '#2F80ED', soft: '#EAF2FE', softBorder: '#CFE1FB', glow: 'rgba(47,128,237,0.28)',
        },
        submitted: {
            label: 'Submitted', Icon: AssignmentTurnedInIcon,
            color: '#27AE60', soft: '#E9F8EF', softBorder: '#C6EAD6', glow: 'rgba(39,174,96,0.26)',
        },
    };

    const subTab = (id, count) => {
        const {label, Icon, color, soft, softBorder, glow} = subTabMeta[id];
        const isActive = submittedView === id;
        return (
            <Button
                key={id}
                size="small"
                startIcon={<Icon sx={{fontSize: 15, color: isActive ? '#fff' : color}} />}
                onClick={() => setSubmittedView(id)}
                sx={{
                    flex: {xs: 1, sm: '0 0 auto'},
                    borderRadius: '10px', textTransform: 'none', fontSize: '12.5px', fontWeight: 700,
                    px: 1.75, py: 0.7, minWidth: 0,
                    background: isActive ? color : soft,
                    color: isActive ? '#fff' : color,
                    border: `1px solid ${isActive ? color : softBorder}`,
                    boxShadow: isActive ? `0 3px 10px ${glow}` : 'none',
                    transition: 'background 0.15s, box-shadow 0.15s',
                    '&:hover': {
                        background: isActive ? color : soft,
                        filter: isActive ? 'brightness(0.94)' : 'brightness(0.97)',
                        boxShadow: isActive ? `0 3px 10px ${glow}` : 'none',
                    },
                    '& .MuiButton-startIcon': {mr: 0.6},
                }}
            >
                {label}
                <Box component="span" sx={{
                    ml: 0.7, px: '7px', borderRadius: '7px', fontSize: '10.5px', fontWeight: 700, lineHeight: 1.65,
                    background: isActive ? 'rgba(255,255,255,0.26)' : '#fff',
                    color: isActive ? '#fff' : color,
                    border: `1px solid ${isActive ? 'rgba(255,255,255,0.34)' : softBorder}`,
                }}>
                    {count}
                </Box>
            </Button>
        );
    };

    return (
        <Box>
            <CustomButtoncolor
                handleClick={() => handleFetchForm()}
                mainColor={"#A533B8"}
                style={{
                    borderRadius: "4px",
                    padding: '10px 15px',
                    width: fwidth,
                    fontSize: "17px !important",
                    ...crmStyle,
                    '@media (max-width:450px)': { fontSize: '13px' },
                }}
                val={"Client Form"}
                icon={isbtn ? <CancelIcon /> : <ArticleIcon />}
            />

            <Drawer
                anchor="right"
                open={treatmentForm !== null}
                onClose={() => setTreatmentForm(null)}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: 520, md: 600 },
                        maxWidth: '100vw',
                        background: '#fff',
                        boxShadow: '-12px 0 40px rgba(0,0,0,0.10)',
                    },
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    {/* Header */}
                    <Box sx={{position: 'relative', display: 'flex', alignItems: 'flex-start', gap: 1.25, px: 2.5, py: 2, borderBottom: '1px solid #F1F2F6', flexShrink: 0}}>
                        <Box sx={{width: 42, height: 42, borderRadius: '10px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                            <ArticleIcon sx={{color: '#A72C68', fontSize: 22}} />
                        </Box>
                        <Box sx={{flex: 1, pr: 3}}>
                            <Typography sx={{fontWeight: 700, fontSize: '18px', color: '#1a1a2e', lineHeight: 1.2, fontFamily: 'helvetica-lt-std-bold,sans-serif'}}>
                                Client Forms
                            </Typography>
                            <Typography sx={{fontSize: '12px', color: '#8a8d97', mt: '2px'}}>
                                Access and manage all client forms in one place.
                            </Typography>
                        </Box>
                        <IconButton size="small" onClick={() => setTreatmentForm(null)} sx={{position: 'absolute', top: 10, right: 10, color: '#9A9797', '&:hover': {color: '#EB5757', background: '#ffeaea'}}}>
                            <CloseIcon sx={{fontSize: 18}} />
                        </IconButton>
                    </Box>

                    {loading ? (
                        <Box sx={{flex: 1, minHeight: '200px'}}><Waveloading /></Box>
                    ) : (
                        <Box ref={scrollableRef} sx={{flex: 1, overflow: 'auto'}}>
                            {/* Search */}
                            <Box sx={{display: 'flex', gap: 1, px: 2.5, pt: 2, pb: 1.5, alignItems: 'center'}}>
                                <TextField
                                    fullWidth size="small" placeholder="Search forms..." value={search} onChange={handleChanges}
                                    InputProps={{startAdornment: <SearchIcon sx={{color: '#a0a4ab', fontSize: 18, mr: 1}} />}}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {borderRadius: '10px', background: '#F7F8FB', '& fieldset': {borderColor: '#ECEDF2'}, '&:hover fieldset': {borderColor: '#E5A8C2'}, '&.Mui-focused fieldset': {borderColor: '#A72C68'}},
                                        '& .MuiInputBase-input': {height: '15px', py: '10px', fontSize: '13px'},
                                    }}
                                />
                            </Box>

                            {/* Filter tabs */}
                            <Box sx={{display: 'flex', gap: 0.75, px: 2.5, pb: 1.5, flexWrap: 'wrap'}}>
                                {tabs.map(t => {
                                    const isActive = active === t.id;
                                    return (
                                        <Button
                                            key={t.id}
                                            size="small"
                                            startIcon={t.icon}
                                            onClick={() => t.id === 3 ? handleSubmitted() : setActive(t.id)}
                                            sx={{
                                                borderRadius: '10px', textTransform: 'none', fontSize: '12px', fontWeight: 600, px: 1.5, py: 0.75, minWidth: 0,
                                                background: isActive ? '#A72C68' : '#F3F4F8',
                                                color: isActive ? '#fff' : '#3b4252',
                                                border: isActive ? '1px solid #A72C68' : '1px solid #ECEDF2',
                                                boxShadow: isActive ? '0 2px 6px rgba(167,44,104,0.25)' : 'none',
                                                '&:hover': {background: isActive ? '#921F58' : '#EAEBF1'},
                                                '& .MuiButton-startIcon': {mr: 0.5},
                                            }}
                                        >
                                            {t.label}
                                        </Button>
                                    );
                                })}
                            </Box>

                            {/* Form rows */}
                            <Box sx={{px: 2.5, pb: 2}}>
                                {active === 0 && (() => {
                                    const consent = filteredForms || [];
                                    const service = filteredCustomerForm || [];
                                    const chart = filteredChartForm || [];
                                    if (!consent.length && !service.length && !chart.length) return emptyMsg('No Forms Found.');
                                    return <>
                                        {consent.map(f => formRow(f, 'Consent', () => onFormOpen(f), mailBtn(f)))}
                                        {service.map(f => formRow(f, 'Service', () => onFormOpen(f), mailBtn(f)))}
                                        {chart.map(f => formRow(f, 'Chart', () => onFormOpen(f), <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>{mailBtn(f)}{f?.is_submitted && <CheckCircleIcon sx={{color: '#27AE60', fontSize: 18}} />}</Box>))}
                                    </>;
                                })()}

                                {active === 4 && (filteredForms?.length > 0
                                    ? filteredForms.map(f => formRow(f, 'Consent', () => onFormOpen(f), mailBtn(f)))
                                    : emptyMsg('No Consent Form Found'))}

                                {active === 1 && (filteredCustomerForm?.length
                                    ? filteredCustomerForm.map(f => formRow(f, 'Service', () => onFormOpen(f), mailBtn(f)))
                                    : emptyMsg('No Customer/Service Form Found.'))}

                                {active === 2 && (filteredChartForm?.length
                                    ? filteredChartForm.map(f => formRow(f, 'Chart', () => onFormOpen(f), <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>{mailBtn(f)}{f?.is_submitted && <CheckCircleIcon sx={{color: '#27AE60', fontSize: 18}} />}</Box>))
                                    : emptyMsg('No Chart Form Found.'))}

                                {active === 3 && <>
                                    {/* Two halves of the same story: what we emailed out, and what came back. */}
                                    <Box sx={{
                                        display: 'flex', gap: 0.75, mb: 1.75, p: '5px',
                                        background: '#F8F8FB', border: '1px solid #F0F1F4', borderRadius: '13px',
                                        width: {xs: '100%', sm: 'fit-content'},
                                    }}>
                                        {subTab('sent', filteredSentForms.length)}
                                        {subTab('submitted', submittedCount)}
                                    </Box>

                                    {submittedView === 'sent' && (filteredSentForms.length > 0
                                        ? filteredSentForms.map(entry => sentRow(entry))
                                        : emptyMsg(search
                                            ? 'No sent forms match your search.'
                                            : 'No forms sent yet. Use the mail icon on a form to email it to this client.'))}

                                    {submittedView === 'submitted' && (
                                        (filteredSubmitForm?.length || filteredSubmitCustomerForm?.length || filteredSubmitChartForm?.length)
                                            ? <>
                                                {filteredSubmitForm?.length > 0 && <>
                                                    <Typography sx={{mt: '8px', mb: '8px', fontSize: '12px', fontWeight: 700, color: '#8a8d97', textTransform: 'uppercase', letterSpacing: '0.4px'}}>Consent Submitted</Typography>
                                                    {filteredSubmitForm.map(f => formRow(f, 'Consent', () => onSubmittedOpen(f), f?.is_submitted && <Typography sx={{fontSize: '11px', fontWeight: 600, color: '#555'}}>{f?.submitted_time}</Typography>))}
                                                </>}
                                                {filteredSubmitCustomerForm?.length > 0 && <>
                                                    <Typography sx={{mt: '16px', mb: '8px', fontSize: '12px', fontWeight: 700, color: '#8a8d97', textTransform: 'uppercase', letterSpacing: '0.4px'}}>Customer Service Submitted</Typography>
                                                    {filteredSubmitCustomerForm.map(f => formRow(f, 'Service', () => onSubmittedOpen(f), f?.is_submitted && <Typography sx={{fontSize: '11px', fontWeight: 600, color: '#555'}}>{f?.submitted_time}</Typography>))}
                                                </>}
                                                {filteredSubmitChartForm?.length > 0 && <>
                                                    <Typography sx={{mt: '16px', mb: '8px', fontSize: '12px', fontWeight: 700, color: '#8a8d97', textTransform: 'uppercase', letterSpacing: '0.4px'}}>Submitted Chart Form</Typography>
                                                    {filteredSubmitChartForm.map(f => formRow(f, 'Chart', () => onSubmittedOpen(f), f?.is_submitted && <Typography sx={{fontSize: '11px', fontWeight: 600, color: '#555'}}>{f?.submitted_time}</Typography>))}
                                                </>}
                                            </>
                                            : emptyMsg('No Forms Found.')
                                    )}
                                </>}
                            </Box>
                        </Box>
                    )}
                </Box>
            </Drawer>

            <LinkModal open={isModalOpen} onClose={closeModal} linkUrl={selectedLinkUrl} />
        </Box>
    );
};

export default TreatmentFormButton;
